import usePageMeta from '../../hooks/usePageMeta'

const PageMeta = (props = {}) => {
  usePageMeta(props)
  return null
}

export default PageMeta
